import * as liveTrainStatusActions from './../actions/liveTrainStatusActions';
import React from 'react';

type actualDepartureDetailsType = {
  actualDepartureTime?: string | undefined | null;
  actualDepartureDate?: string | undefined | null;
};

type actualArrivalDetailsType = {
  actualArrivalTime?: string | undefined | null;
  actualArrivalDate?: string | undefined | null;
};

type scheduledDepartureDetailsType = {
  scheduledDepartureTime?: string | undefined | null;
  scheduledDepartureDate?: string | undefined | null;
};

type scheduledArrivalDetailsType = {
  scheduledArrivalTime?: string | undefined | null;
  scheduledArrivalDate?: string | undefined | null;
};

type intermediateStationLtsDetailsType = {
  stationName: string | undefined | null;
  stationCode: string | undefined | null;
  scheduledDepartureDetails: scheduledDepartureDetailsType;
  scheduledArrivalDetails: scheduledArrivalDetailsType;
  distanceFromOriginStation: string | undefined | null;
  stoppingStation?: boolean | undefined | null;
  divertedStation?: boolean | undefined | null;
  cancelledStation?: boolean | undefined | null;
};

type haltingStationLtsDetailsType = {
  stationName: string | undefined | null;
  stationCode: string | undefined | null;
  actualDepartureDetails?: actualDepartureDetailsType;
  scheduledDepartureDetails: scheduledDepartureDetailsType;
  actualArrivalDetails?: actualArrivalDetailsType;
  scheduledArrivalDetails: scheduledArrivalDetailsType;
  platformNumber: string | undefined | null;
  stoppingMinutes: string | undefined | null;
  distanceFromOriginStation: string | undefined | null;
  arrivedStationOnTime?: boolean | undefined | null;
  departedStationOnTime?: boolean | undefined | null;
  stoppingStation?: boolean | undefined | null;
  divertedStation?: boolean | undefined | null;
  cancelledStation?: boolean | undefined | null;
  intermediateStations: intermediateStationLtsDetailsType;
  hasArrived: boolean | undefined | null;
  hasDeparted: boolean | undefined | null;
};

export type ltsPageStateType =
  | {
      isLoading: boolean | undefined | null;
      daysOfRun: string | undefined | null;
      trainStartDate: string | undefined | null;
      trainName: string | undefined | null;
      trainNumber: string | undefined | null;
      haltingStationCollection: haltingStationLtsDetailsType[] | null | undefined;
      originStation: haltingStationLtsDetailsType | null | undefined;
      destinationStation: haltingStationLtsDetailsType | null | undefined;
      currentStation: haltingStationLtsDetailsType | null | undefined;
      nextStation: haltingStationLtsDetailsType | null | undefined;
      currentIntermediateStation?: intermediateStationLtsDetailsType | null | undefined;
      trainStartedFromSource: boolean | null | undefined;
      trainReachedDestination: boolean | null | undefined;
      firstStoppingStation?: haltingStationLtsDetailsType | null | undefined;
      lastStoppingStation?: haltingStationLtsDetailsType | null | undefined;
      trainFullyCancelled?: boolean | null | undefined;
      trainFullyDiverted?: boolean | null | undefined;
      totalDistance: string | undefined | null;
      timerRefreshTimeStamp: Date | null | undefined;
    }
  | null
  | undefined;

type ltsPageActionType = {
  type: string;
  data: any;
};

export type ltsPageContextType = {
  searchWidgetState: ltsPageStateType;
  searchWidgetDispatch: React.Dispatch<ltsPageActionType>;
};

export const ltsPageInitialState: ltsPageStateType = {
  isLoading: false,
  daysOfRun: '0000000',
  trainStartDate: undefined,
  trainName: undefined,
  trainNumber: undefined,
  haltingStationCollection: undefined,
  originStation: undefined,
  destinationStation: undefined,
  currentStation: undefined,
  nextStation: undefined,
  currentIntermediateStation: undefined,
  trainStartedFromSource: undefined,
  trainReachedDestination: undefined,
  firstStoppingStation: undefined,
  lastStoppingStation: undefined,
  trainFullyCancelled: undefined,
  trainFullyDiverted: undefined,
  totalDistance: undefined,
  timerRefreshTimeStamp: undefined
};

export const liveTrainStatusReducer = (state: ltsPageStateType, action: ltsPageActionType): ltsPageStateType => {
  if (typeof action !== 'object') {
    return state;
  }
  switch (action.type) {
    case liveTrainStatusActions.ACTION_UPDATE_LTS_STATION_DETAILS: {
      return {
        ...state,
        ...action.data,
        isLoading: false
      };
    }
    case liveTrainStatusActions.ACTION_LTS_FETCH_START: {
      return {
        ...state,
        ...action.data,
        isLoading: true
      };
    }
    default: {
      return state;
    }
  }
};
